<div class="position-relative">
  <div class="sidebar" [class.mobile-open]="isSidebarOpen">
    <div class="icon">
      <div class="sidebar-header">
        <span class="global-text">Accomodation Management</span>

        <button
          type="button"
          class="toggle-btn"
          (click)="toggleSidebar()"
          [attr.aria-expanded]="isSidebarOpen"
          aria-label="Toggle navigation menu"
        >☰</button>
      </div>
    </div>

    <div class="side-bar-wrapper">
      @if(viewAs){
      <div class="view-as-banner" role="status">
        <span class="view-as-text">
          Viewing as <strong>{{ viewAs.roleName }}</strong>
          @if(viewAs.establishmentName){ · {{ viewAs.establishmentName }} } @else { · Global }
        </span>
        <button type="button" class="view-as-exit" (click)="exitViewAs()">Exit</button>
      </div>
      }
      <div class="tabList">
        @for(list of menuItems; track list.route || list.label){

        <!-- Normal Menu -->
        @if(!list.children){

        <a
          class="menu"
          [routerLink]="list.route ? ['/dashboard', list.route] : null"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="closeSidebar()"
        >

          <img [src]="list.icon" (error)="useFallbackIcon($event)" alt="" class="menu-icon" />

          <span class="menu-label">
            {{list.label}}
          </span>

        </a>

        }

        <!-- Parent Menu -->
        @if(list.children){

        <button
          type="button"
          class="menu reports-menu"
          (click)="toggleSubMenu(list)"
          [attr.aria-expanded]="openedMenu === list.label"
        >

          <div class="reports-header">
            <div class="report-title">
              <img [src]="list.icon" (error)="useFallbackIcon($event)" alt="" class="menu-icon" />

              <span class="menu-label">
                {{list.label}}
              </span>
            </div>

            <span class="arrow" [class.rotate]="openedMenu === list.label">
              ▼
            </span>
          </div>

        </button>

        <!-- Submenu -->
        @if(openedMenu === list.label){

        <div class="submenu">

          @for(child of list.children; track child.route || child.label){

          <a
            class="submenu-item"
            [routerLink]="child.route ? ['/dashboard', child.route] : null"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="closeSidebar()"
          >
            {{child.label}}

          </a>

          }

        </div>

        }

        }

        }
      </div>

    </div>

    <div class="footer-sidebar">
      @if(canChangeContext){
      <a
        class="menu"
        [routerLink]="['/', contextSelectRoute]"
        (click)="closeSidebar()"
      >
        <img src="icons/building.svg" (error)="useFallbackIcon($event)" alt="" class="menu-icon" />
        <span class="menu-label">Change context</span>
      </a>
      }

      @if(showBranchPicker){
      <div class="branch-picker">
        <label class="branch-label" id="side-nav-branch-label">Branch</label>
        <mat-form-field
          class="ac-select-field sidebar-select-field"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <mat-select
            aria-labelledby="side-nav-branch-label"
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            [disabled]="isBranchSwitching"
            [value]="activeEstablishmentId"
            (selectionChange)="switchBranch($event.value)"
          >
          @for(est of establishments; track est.establishmentId){
          <mat-option [value]="est.establishmentId">{{ establishmentNameOf(est) }}</mat-option>
          }
          </mat-select>
        </mat-form-field>
      </div>
      }

      <a class="menu-disabled">
        <img src="icons/user-line.svg" (error)="useFallbackIcon($event)" alt="" class="menu-icon" />
        <div class="user-info">
          <span class="user-name">{{name}}</span>
          @if(roleName){
          <span class="role-name">{{roleName}}</span>
          }
          @if(contextLabel){
          <span class="context-name">{{contextLabel}}</span>
          }
        </div>
      </a>

      <a class="menu" (click)="logOut()">
        <img src="icons/logout.svg" (error)="useFallbackIcon($event)" alt="" class="menu-icon" />

        <!--  ADDED -->
        <span class="menu-label">Log out</span>
      </a>
    </div>
  </div>

  <div class="routerBody">
    <router-outlet></router-outlet>
  </div>
</div>
